module.exports = __webpack_public_path__ + "img/question-circle.8c6f9b66.svg";